import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Spinner from '../others/Spinner';
import html2pdf from 'html2pdf.js';
import DocumentPaymentControl from '../documents/DocumentPaymentControl';
import DocumentCheckPolicy from '../documents/DocumentCheckPolicy';
import DocumentContract from '../documents/Contract/DocumentContract';
import DocumentPaperLetter from '../documents/DocumentPaperLetter';
import DocumentPromissoryNote from '../documents/DocumentPromissoryNote';

class GroupPrintDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = this.state_init();

    this.handleChange = this.handleChange.bind(this);
  }

  requisition = JSON.parse(localStorage.getItem('requisition'));

  state_init = () => {
    return {
      todos: false,
      control_pagos: false,
      pagare: false,
      poliza_cheque: false,
      contrato: false,
      varius_docs: '',
      loading: false,
      isGroup: false,
    };
  };

  componentDidMount = () => {
    this.setState({
      isGroup: this.requisition?.Grupo?.Socios?.length > 1,
    });
  };

  handleChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    let { state } = this;

    if (name === 'todos') {
      state[name] = value;
      state.control_pagos = value;
      state.pagare = value;
      state.poliza_cheque = value;
      state.contrato = value;

      this.setState(state);
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  getPaymentControl = () =>
    this.generatePDF('control-pagos', 'Control de pagos');

  getPromissoryNotes = () =>
    this.generatePDF(
      'pagare',
      'Pagarés',
      this.state.isGroup ? 0.511811 : 0.787402 // si es grupal 1.3cm, si es individual 2cm
    );

  getCheckPolicy = () => this.generatePDF('paper-policy', 'Póliza');

  getContract = () =>
    this.generatePDF(
      'contrato_credito',
      'Contrato',
      0.787402 // 2cm in inches
    );

  generatePDF = (idContent, documentName = 'Documento', margin = 0) => {
    return new Promise((resolve, reject) => {
      var element = document.getElementById(idContent);

      var opt = {
        margin,
        filename: `${this.requisition?.Grupo.nombre} - ${documentName}.pdf`,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: {
          unit: 'in',
          format: 'letter',
          orientation: 'portrait',
        },

        pagebreak: {
          mode: ['avoid-all', 'css', 'legacy'],
          before: '.beforeClass',
          after: '.afterClass',
        },
      };

      html2pdf()
        .set(opt)
        .from(element)
        .save()
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  handlePaymentControl = () => {
    this.setState({
      loading: true,
    });
    this.getPaymentControl().finally(() => {
      this.setState({
        loading: false,
      });
    });
  };

  handlePromissoryNotes = () => {
    this.setState({
      loading: true,
    });
    this.getPromissoryNotes().finally(() => {
      this.setState({
        loading: false,
      });
    });
  };

  handleCheckPolicy = () => {
    this.setState({
      loading: true,
    });
    this.getCheckPolicy().finally(() => {
      this.setState({
        loading: false,
      });
    });
  };

  handleContract = () => {
    this.setState({
      loading: true,
    });

    this.getContract().finally(() => {
      this.setState({
        loading: false,
      });
    });
  };

  handlePrintSomeDocuments = async () => {
    this.setState({
      loading: true,
    });

    if (this.state.control_pagos === true) {
      await this.getPaymentControl();
    }

    if (this.state.pagare === true) {
      await this.getPromissoryNotes();
    }

    if (this.state.poliza_cheque === true) {
      await this.getCheckPolicy();
    }

    if (this.state.contrato === true) {
      await this.getContract();
    }

    this.setState({
      loading: false,
    });
  };

  render() {
    return (
      <>
        <Spinner loading={this.state.loading} />
        <button
          type="button"
          className="btn btn-success mr-3 mt-3 mt-md-0"
          data-toggle="modal"
          data-target="#printDocuments"
        >
          Imprimir documentos
        </button>

        <div
          className="modal fade"
          id="printDocuments"
          tabIndex="-1"
          aria-labelledby="printDocumentsLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="printDocumentsLabel">
                  Imprimir documentos
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <table className="table m-0">
                  <thead>
                    <tr>
                      <th className="border-0">
                        <input
                          type="checkbox"
                          id="todos"
                          name="todos"
                          value={this.state.todos}
                          checked={this.state.todos}
                          onChange={this.handleChange}
                        />
                      </th>
                      <th colSpan="2" className="border-0">
                        Documentos
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="checkbox"
                          id="checkbox_control_pagos"
                          name="control_pagos"
                          value={this.state.control_pagos}
                          checked={this.state.control_pagos}
                          onChange={this.handleChange}
                        />
                      </td>
                      <td>
                        <label htmlFor="checkbox_control_pagos">
                          Control de pagos
                        </label>
                      </td>
                      <td className="text-right">
                        <div
                          className="d-flex justify-content-end"
                          style={{ gap: '5px' }}
                          role="group"
                          aria-label="Basic example"
                        >
                          <Link
                            to={`${this.props.match.url}/control-pagos`}
                            target="_blank"
                            title="Vista previa"
                            className="btn btn-primary btn-sm"
                          >
                            <i className="fas fa-eye"></i> Vista previa
                          </Link>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={this.handlePaymentControl}
                          >
                            <i className="fas fa-print"></i> Imprimir
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          type="checkbox"
                          id="checkbox_pagare"
                          name="pagare"
                          value={this.state.pagare}
                          checked={this.state.pagare}
                          onChange={this.handleChange}
                        />
                      </td>
                      <td>
                        <label htmlFor="checkbox_pagare">Pagaré</label>
                      </td>
                      <td className="text-right">
                        <div
                          className="d-flex justify-content-end"
                          style={{ gap: '5px' }}
                          role="group"
                          aria-label="Basic example"
                        >
                          <Link
                            to={`${this.props.match.url}/pagare?isGroup=${this.state.isGroup}`}
                            target="_blank"
                            title="Vista previa"
                            className="btn btn-primary btn-sm"
                          >
                            <i className="fas fa-eye"></i> Vista previa
                          </Link>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={this.handlePromissoryNotes}
                          >
                            <i className="fas fa-print"></i> Imprimir
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          type="checkbox"
                          id="checkbox_poliza"
                          name="poliza_cheque"
                          value={this.state.poliza_cheque}
                          checked={this.state.poliza_cheque}
                          onChange={this.handleChange}
                        />
                      </td>
                      <td>
                        <label htmlFor="checkbox_poliza">
                          Póliza de cheque
                        </label>
                      </td>
                      <td className="text-right">
                        <div
                          className="d-flex justify-content-end"
                          style={{ gap: '5px' }}
                          role="group"
                          aria-label="Basic example"
                        >
                          <Link
                            to={`${this.props.match.url}/poliza`}
                            target="_blank"
                            title="Vista previa"
                            className="btn btn-primary btn-sm"
                          >
                            <i className="fas fa-eye"></i> Vista previa
                          </Link>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={this.handleCheckPolicy}
                          >
                            <i className="fas fa-print"></i> Imprimir
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input
                          type="checkbox"
                          id="checkbox_contrato"
                          name="contrato"
                          value={this.state.contrato}
                          checked={this.state.contrato}
                          onChange={this.handleChange}
                        />
                      </td>
                      <td>
                        <label htmlFor="checkbox_contrato">Contrato</label>
                      </td>
                      <td className="text-right">
                        <div
                          className="d-flex justify-content-end"
                          style={{ gap: '5px' }}
                          role="group"
                          aria-label="Basic example"
                        >
                          <Link
                            to={`${this.props.match.url}/contrato_credito`}
                            target="_blank"
                            title="Vista previa"
                            className="btn btn-primary btn-sm"
                          >
                            <i className="fas fa-eye"></i> Vista previa
                          </Link>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={this.handleContract}
                          >
                            <i className="fas fa-print"></i> Imprimir
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <td className="text-right" colSpan="3">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={this.handlePrintSomeDocuments}
                          disabled={
                            !(this.state.todos === true) &&
                            !(
                              this.state.control_pagos === true ||
                              this.state.pagare === true ||
                              this.state.poliza_cheque === true ||
                              this.state.contrato === true
                            )
                          }
                        >
                          Imprimir selección
                        </button>
                      </td>
                    </tr>
                  </thead>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="d-none">
          <div id="control-pagos">
            <DocumentPaymentControl />
          </div>

          <div className="d-flex flex-column align-items-center justify-content-center">
            <DocumentPaperLetter
              style={
                this.state.isGroup
                  ? styles.paddingPromissoryNoteGrupal
                  : styles.paddingPromissoryNoteIndividual
              }
            >
              <div id="pagare">
                <DocumentPromissoryNote />
              </div>
            </DocumentPaperLetter>
          </div>

          <div id="poliza">
            <DocumentCheckPolicy />
          </div>

          <div className="d-flex flex-column align-items-center justify-content-center">
            <DocumentPaperLetter style={styles.containerContract}>
              <div id="contrato_credito">
                <DocumentContract />
              </div>
            </DocumentPaperLetter>
          </div>
        </div>
      </>
    );
  }
}

export default GroupPrintDocuments;

export const styles = {
  containerContract: { padding: '2cm' },
  paddingPromissoryNoteGrupal: { padding: '1.3cm' },
  paddingPromissoryNoteIndividual: { padding: '2cm' },
};
